module.exports = __webpack_public_path__ + "media/seo/de-d19541b1.jpg";